export const Categories = {
  CATEGORY_STONE: 'EVOLUTION STONE',
  CATEGORY_TRAIN_PASS: 'TRAIN_PASS',
  CATEGORY_BIKE: 'BIKE',
  CATEGORY_FLASHLIGHT: 'FLASHLIGHT',
  CATEGORY_POTION_FULL_HEAL: 'POTION_FULL_HEAL',
  CATEGORY_POTION_FULL_HEAL_ENDANGERED: 'POTION_FULL_HEAL_ENDANGERED',
}

// Ikony pro kategorie itemu bez vlastniho obrazku (viz claude/components/
// README.md - v assets/pic/ zatim neni items/ slozka, mdi-* ikony jsou
// levnejsi nez kreslit/hledat art pro kazdy novy item). Sdileno mezi
// Items.vue a UseItemButton.vue, ktere obe potrebuji stejne mapovani.
export const CategoryIcons = {
  TRAIN_PASS: 'mdi-train',
  BIKE: 'mdi-bicycle',
  FLASHLIGHT: 'mdi-flashlight',
  POTION_FULL_HEAL: 'mdi-bottle-tonic-plus-outline',
  POTION_FULL_HEAL_ENDANGERED: 'mdi-bottle-tonic-plus',
}

// Poradi "power rank" bucketu evolucnich kamenu od nejslabsiho k
// nejsilnejsimu - musi zrcadlit StonePowerRankEnum::RANKS
// (api/src/Enum/StonePowerRankEnum.php), jinak by tolerance sily na
// trzisti (TradeHub.vue) neodpovidala tomu, co validuje backend.
export const StonePowerRankOrder = [
  'Chipped',
  'Flawed',
  'Normal',
  'Flawless',
  'Perfect',
  'Total Perfect',
  'Legendary',
  "God's",
]

// Dolni hranice (exkluzivni) stejneho bucketu jako StonePowerRankEnum::RANKS
// (api/src/Enum/StonePowerRankEnum.php) - slouzi jen k zobrazeni rozsahu
// expu u jednotlivych ranku (StonePowerRankLegend.vue), na samotnou
// toleranci sily na trzisti se nepouziva (to resi backend).
export const StonePowerRankThresholds = [0, 8, 13, 19, 26, 34, 50, 80]

